import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, DatePicker, List, Row, Table } from 'antd'
import moment from 'moment'
import { CSVLink } from 'react-csv'
// import { useDownloadExcel } from 'react-export-table-to-excel';

import eventListData from '../../data/event-list-view-data.json'
import  util  from '../../utils/functions/custom';

import eventsAPI from '../../services/eventsAnalyticsService';

export default function EventsListView() {

  const [eventList, setEventList] = useState([])
  const [csvData, setCsvData] = useState([]);
  const [eventYear, setEventYear] = useState(util.getCurrentRepotYear());
  const [filterId, setFilterId] = useState();

  useEffect(() => {
    generateDate(eventListData);
  }, [])

  const generateDate = (data) => {
    const dd = data.map((event) => ({
      name: event.name,
      venue: event.venue,
      dates: event.dates,
      // address: event.address.street + ", " + event.address.cityOrTown + ", " + event.address.postalCode,
      // venueDistrict: event.venueDistrict,
      // venueProvince: event.venueProvince,
      hostOrganisation: event.hostOrganisation
    }))
    const csvData1 = data.map((element) => ({
      "Name": element.name,
      "Venue Name": element.venue,
      "Event Date": element.dates,
      // "Address": element.address.street + ", " + element.address.cityOrTown + ", " + element.address.postalCode,
      // "Venue District": element.venueDistrict,
      // "Venue Province": element.venueProvince,
      "Host Organisation Name": element.hostOrganisation
    }));
    console.log("DDDDD", dd)
    setEventList(dd);
    setCsvData(csvData1);
  }
  const columns = [
    {
      title: "Event Name",
      dataIndex: "name",
      key: "name",
      // sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Venue Name",
      dataIndex: "venue",
      key: "venue",
    },
    {
      title: "Event Date",
      dataIndex: "dates",
      key: "dates",
      // sorter: (a, b) => a.lastModified.localeCompare(b.lastModified),
    },

    {
      title: "Venue Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Venue District",
      dataIndex: "venueDistrict",
      key: "venueDistrict",
    },
    {
      title: "Venue Province",
      dataIndex: "venueProvince",
      key: "venueProvince",
    },
    {
      title: "Host Organisation Name",
      dataIndex: "hostOrganisation",
      key: "hostOrganisation",
    },
  ];

  // const tableRef = useRef(null);

  // const { onDownload } = useDownloadExcel({
  //   currentTableRef: tableRef.current,
  //   filename: 'Users table',
  //   sheet: 'Users'
  // })

  const onYearChange = (year) => {
    var eventYear = moment(year).format("YYYY");
    console.log("Event year on change",eventYear);
    setEventYear(eventYear);
    getEventsData(eventYear);
      // getEventsData(eventYear);
    
  };

  const getEventsData = async (repYear) => {
    try {
      const response = await eventsAPI.getEvents(repYear);
      if (response && response.status === 200) {
        const { data } = response;
        console.log("Event Data: ", data);
        // const selectedEvent = data[0];
        // setFilterId(selectedEvent.id);
        generateDate(data)
        console.log("After Generating")
      } else {
        setFilterId();
      }
    } catch (error) { }
  };
  return (
    <div className='content'>
      <Col xs={24}>
        <h2 className="report-heading">Events List</h2>
      </Col>
      {/* <div>List of all ratified events</div> */}
      <div className='report-nys-content'>
        <div className="reportYear">
          <Row
            style={{
              borderRadius: "10px",
            }}
          >
            <Col
              xs={11}
              md={11}
              style={{
                borderRadius: "10px",
              }}
            >
              <div className="reportYearContainer">
                <div
                  style={{
                    margin: "0px auto",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Report year : &nbsp;
                  <DatePicker
                    picker="year"
                    onChange={onYearChange}
                    // disabledDate={disabledDate}
                    // value={moment(reportYear, "YYYY")}
                    allowClear={false}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <br />
        <CSVLink
          filename={"TableContent.csv"}
          data={csvData}
          className="btn btn-primary"
        >
          <Button
            style={{ borderRadius: "10px" }}
            key="export"
            type="primary"
          >
            Export to csv
          </Button>
        </CSVLink>
        <br /><br />
        {/* <button onClick={onDownload}> Export excel </button>

      <table ref={tableRef}>
        <tbody>
          <tr>
            <th>Firstname</th>
            <th>Lastname</th>
            <th>Age</th>
          </tr>
          <tr>
            <td>Edison</td>
            <td>Padilla</td>
            <td>20</td>
          </tr>
          <tr>
            <td>Alberto</td>
            <td>Lopez</td>
            <td>94</td>
          </tr>
        </tbody>
      </table> */}

        <Table
          // dataSource={loading ? [] : filteredData}
          dataSource={eventList}
          // locale={{
          //   emptyText: loading ? <Skeleton active={true} /> : <Empty />,
          // }}
          rowKey={(record) => record.key}
          columns={columns}
          bordered

          size="middle"
          key="2"
        />

        <List
          itemLayout="vertical"
          pagination={{
            pageSize: 5,
          }}
          dataSource={eventList}
          renderItem={(event) => (
            <List.Item
              key={event.key}
            >
              <Card className="card-border" style={{ height: "auto" }}>
                <Row>
                  <Col>
                    {<h2><b>{event.name}</b></h2>}
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}><b><span>Event Dates: </span></b>{event.dates}</Col>
                  <Col xs={6}><b><span>Venue: </span></b>{event.venue}</Col>
                  <Col xs={6}><b><span>Host Organisation: </span></b>{event.hostOrganisation}</Col>
                </Row>
                <Row>
                  <Col xs={6}><b><span>Address: </span></b>{event.address}</Col>
                  <Col xs={6}><b><span>District: </span></b>{event.venueDistrict}</Col>
                  <Col xs={6}><b><span>Province: </span></b>{event.venueProvince}</Col>
                </Row>
              </Card>
            </List.Item>
          )}
        />
      </div>
    </div>

  )
}
